import React from 'react'
import { Form, Formik } from 'formik'
import { navigate } from 'gatsby'
import * as Yup from 'yup'
import { Helmet } from 'react-helmet'
import { css } from '@styled-system/css'
import {
  Box,
  Paragraph,
  Span,
  H1,
  Ul,
  ButtonUnstyled,
  Button
} from '@allied-solutions/affinity'
import { useFetchBorrower, useStore } from '../../hooks'
import { AppLayout, Layout } from '../../components'
import illustration from '../enter-reference-id/Illustration.svg'
import confirmwave from '../../images/confirm-wave.svg'
import { ButtonGroup } from '../../components/ButtonGroup'

const ListItem = props => {
  return (
    <Box display="flex" alignItems="center" mb={4}>
      <img
        src={confirmwave}
        alt=""
        css={css({
          mx: 'auto',
          verticalAlign: "middle"
        })}
      />
      <Span ml={3} fontSize={2}>
        {props.children}
      </Span>
    </Box>
  )
}

const CreateAccountPage = props => {
    const { dispatch, state } = useStore()
    const { handleSubmit } = useFetchBorrower(
      '/enter-reference-id/create-account/'
    )

    return(
    <Layout>
     <Helmet>
        <title>Create Account</title>
        <meta
          name="description"
          content="Create Account to start the 5-minute insurance verification process on your own by entering your reference ID number from the letter or email you received."
        />
      </Helmet>
      <Formik
        initialValues={{
          refId: '',
          ...state.form,
        }}
        onSubmit={handleSubmit}
        validationSchema={Yup.object().shape({
          refId: Yup.string().required('Please enter a valid Reference ID.'),
        })}
      >
        {props => (
          <main>
            <Form noValidate>
              <AppLayout
                leftSide={
                  <>
                    <Paragraph
                      mb={6}
                      typeStyle="labelLarge"
                      textAlign="left"
                      color="gray600"
                    >
                      Success!
                    </Paragraph>
                    <H1 className="h5" typeStyle="h5">
                      Create an account!
                    </H1>
                    <Paragraph
                      typeStyle="bodyMedium"
                      textAlign="left"
                      color="gray600"
                      mb={8}
                    >
                      Create an account to check your submission status in the future. If you do not want to create an account, you may close this window.
                      <br />
                      <br />
                    </Paragraph>
                      <Box
                        borderWidth={1}
                        py={8}
                        px={9}
                        ml={6}
                        borderRadius={3}
                        borderColor="grayLight"
                      >
                        <Span
                          fontSize={3}
                          fontWeight="700"
                          color="grayDark"
                          mb={4}
                        >Benefits of an account:</Span>
                        <Ul>
                          <li>
                            <ListItem>
                              Faster access to submission status without needing to call.
                            </ListItem>
                          </li>
                          <li>
                            <ListItem>
                              Detailed next steps if more information is needed.
                            </ListItem>
                          </li>
                          <li>
                            <ListItem>
                              Easily review your loan and their interaction history
                            </ListItem>
                          </li>
                        </Ul>
                      </Box>
                  </>
                }
                rightSide={
                  <img
                    src={illustration}
                    alt=""
                    css={css({
                      display: ['none', null, null, 'block'],
                      mx: 'auto',
                    })}
                  />
                }
                footerButtons={
                  <ButtonGroup display="flex" justifyContent="flex-end">
                    <ButtonUnstyled
                      id="CreateAccount__Button--close"
                      // as={Button}
                      typeStyle="labelLarge"
                      textAlign="right"
                      color="gray600"
                      onClick={() => {
                        dispatch({ type: 'resetForm' })
                        navigate('/')
                      }}
                    >
                      Close
                    </ButtonUnstyled>
                    <Button
                      id="CreateAccount__Button--createanaccount"
                      minWidth={24}
                      ml={['5', '8']}
                      rounded
                      size="md"
                      onClick={() => {
                        dispatch({ type: 'resetForm' })
                        navigate('/')
                      }}
                    >
                      Create an Account
                    </Button>
                  </ButtonGroup>
                }
              />
            </Form>
          </main>
        )}
      </Formik>
    </Layout>)
}

export default CreateAccountPage